const STRINGS = {
	add: gettext('Add'),
	success: gettext('Success'),
	error: gettext('Error'),
	expired: gettext('Expired'),
	expiryDate: gettext('Access Token Expiry Date (UTC)'),
	important: gettext('Important'),
	hidden: gettext('Hidden'),
	revoked: gettext('Revoked'),
	clientId: gettext('Client ID'),
	clientSecret: gettext('Client Secret'),
	accessToken: gettext('Access Token'),
	refreshToken: gettext('Refresh Token'),
	accessTokenScope: gettext('Access Token Scope'),
	refreshedMsg: gettext('Your access token and refresh token have been refreshed'),
	generatedMsg: gettext('Successfully generated new credentials'),
	revokedMsg: gettext('Your credentials have been revoked'),
	generateCredentialsBtn: gettext('Generate Credentials'),
	refreshCredentialsBtn: gettext('Refresh Credentials'),
	revokeCredentialsBtn: gettext('Revoke Credentials'),
	saveBtn: gettext('Save'),
	cancel: gettext('Cancel'),
	cancelBtn: gettext('Cancel'),
	ok: gettext('Ok'),
	copySecretLabel: gettext('Copy client secret to clipboard'),
	credentialsTableHeader: gettext('Credentials'),
	name: gettext('Name'),
	email: gettext('Email'),
	language: gettext('Language'),
	timezone: gettext('Timezone'),
	change: gettext('Change'),
	clear: gettext('Clear'),
	warning: gettext('Warning'),
	primary: gettext('Primary'),
	unsavedChanges: gettext('Unsaved changes'),
	localizationMissing: gettext('Missing localization'),
	enable: gettext('Enable'),
	disable: gettext('Disable'),
	learnMore: gettext('Learn more'),
	fieldErrors: {
		email: gettext('Please enter a valid email address'),
		text: gettext('Field is required'),
		currentPassword: gettext('Please enter your current password'),
		newPassword: gettext('Passwords must be at least 8 characters long, contain at least one number and special character, and have both upper and lower case letters'),
		invalidFirstName: gettext('Invalid first name'),
		invalidLastName: gettext('Invalid last name'),
		invalidEmail: gettext('Invalid email'),
		invalidPassword: gettext('A stronger password is required'),
		invalidOrganizationName: gettext('Organization name is required'),
		invalidCaptcha: gettext('Invalid captcha, please try again'),
		invalidTaxNumber: gettext('Tax number is required'),
	},
	labels: {
		showChangeFields: gettext('Change Value'),
		displayText: gettext('Display Text'),
		loading: gettext('Loading'),
		showCurrencySymbolCheckbox: gettext('Show Currency Symbol'),
		currencySelector: gettext('Currency Selector'),
		edit: gettext('Edit'),
		delete: gettext('Delete'),
		retryVerification: gettext('Retry Verification'),
		retryingVerification: gettext('Retrying Verification'),
		domainActions: gettext('Domain Actions'),
		domainStatus: gettext('Domain Status'),
		domainLanguage: gettext('Domain Language'),
		tableRow: gettext('Table Row'),
		more: gettext('Show More'),
		rename: gettext('Rename Status'),
	},
	apiCredentials: {
		generated: gettext('API credentials have been generated'),
		regenerated: gettext('Refreshed API access token and refresh token'),
		revoked: gettext('Credentials have been revoked'),
	},
	copyStrings: {
		success: gettext('Client secret has been copied to clipboard'),
		error: gettext('Unable to copy client secret to clipboard, please copy it manually before continuing'),
	},
	secretHiddenTitle: gettext('Client secret is unavailable'),
	secretHiddenText: gettext('The client secret is only visible when it is first generated. If you have lost your client secret, please revoke these credentials and regenerate.'),
	copySecretTitle: gettext('Copy your client secret!'),
	copySecretText: gettext('Client secrets are only displayed when credentials are first generated. Please copy this value and store it in a safe place. If you lose your secret, you will need to revoke the credentials and regenerate.'),
	apiNameText: gettext('Apply Connect'),
	apiDescriptionText: gettext('SurveyMonkey Apply\'s REST API allows you to create integrations that can get up to date information on submissions, users, programs and more!'),
	documentationHeaderText: gettext('Apply Connect Documentation'),
	documentationDescriptionText: gettext('Our documentation provides sample requests and responses for all the methods that are currently supported and allows you to make calls directly from within the documentation.'),
	documentationWarningText: gettext('Calls made from the documentation use your sites live data, so use with caution.'),
	documentationBtn: gettext('Documentation'),
	oauthCredentialsHeader: gettext('OAuth2 Credentials'),
	oauthCredentialsText: gettext('SurveyMonkey Apply\'s uses OAuth2 to authenticate all API requests. Your '
		+ 'credentials are unique and tied to your user account, so make sure to keep them safe and to yourself'),
	revokeCredentialsModalBody: gettext(
		'Are you sure you want to revoke your API credentials? This cannot be undone and any integrations '
		+ 'that use these credentials will immediately stop working.',
	),
	revokeConfirmationText: gettext(
		'I acknowledge that revoking API credentials will cause an interruption in any integration that is '
		+ 'using them and understand that revoking credentials cannot be undone. I further understand that in order '
		+ 'to restore access I will need to generate and use new credentials.',
	),
	StageHistoryTable: {
		id: gettext('ID'),
		round_id: gettext('Stage ID'),
		round_name: gettext('Stage Name'),
		round_type: gettext('Stage Type'),
		event_name: gettext('Event'),
		timestamp: gettext('Timestamp'),
		historyWarning: gettext(
			'This application was created before September 12th, 2024 and the stage history log may be incomplete.',
		),
		applicantStage: gettext('Application Stage'),
		simpleReviewStage: gettext('Simple Review Stage'),
		advancedReviewStage: gettext('Advanced Review Stage'),
		holdingStage: gettext('Holding Stage'),
		reviewGroup: gettext('Review Group'),
		unknown: gettext('Unknown (Deleted)'),
		error: gettext('An error occurred while fetching stage history'),
		noData: gettext('No stage history data available for this application'),
		timestampInfo: gettext('All timestamps are in the sites timezone'),
		labelJumpToPage: (page) => interpolate(gettext('Page %(page)s'), { page }, true),
		placeholderJumpToPage: gettext('Jump to page'),
		labelLegend: (firstRowOnPage, lastRowOnPage, totalRows) => interpolate(
			gettext('Showing %(first)s – %(last)s of %(total)s'),
			{ first: firstRowOnPage, last: lastRowOnPage, total: totalRows },
			true
		),
		labelRowsPerPage: (rowsPerPage) => interpolate(gettext('%(count)s per page'), { count: rowsPerPage }, true),
	},
	generalSettingsTitle: gettext('General'),
	siteDetailsTitle: gettext('Site Details'),
	siteDetailsSubtitle: gettext('Enter basic details about your site'),
	siteAccessTitle: gettext('Site Access'),
	siteAccessSubtitle: gettext('Lock or unlock your site to allow everyone or only admins to access it'),
	localizationTitle: gettext('Localization'),
	localizationSubtitle: gettext('Select options to best localize your site'),
	financialManagementTitle: gettext('Financial Management'),
	financialManagementSubtitle: gettext('Keep track of program budgets and funds'),
	lockSiteCheckboxLabel: gettext('Lock the site so it is only accessible by administrators'),
	previewBtn: gettext('Preview'),
	themePreviewText: gettext('Preview also provides access to the CSS editor.'),
	twentyFourHourClock: gettext('24 hour clock'),
	twelveHourClock: gettext('12 hour clock'),
	showCurrencySymbol: gettext('Show country code when displaying currency'),
	deleteBtn: gettext('Delete'),
	themePreviewInfoText: gettext('Preview is for informational purposes only. Styles may differ based on browser, accessibility settings, custom CSS or other factors.'),
	pleaseSelect: gettext('Please select...'),
	toast: {
		success: gettext('Success'),
		error: gettext('Error'),
		domainAdded: gettext('Domain has been added'),
		domainUpdated: gettext('Domain has been updated'),
		domainDeleted: gettext('Domain has been deleted'),
		domainError: gettext('Domain is required'),
		domainInvalid: gettext('Domain is invalid'),
		domainExists: gettext('Domain already exists'),
		domainExistsError: gettext('Domain already exists'),
		settingsSaved: gettext('Site settings have been saved'),
		domainVerified: gettext('Domain has been verified'),
		domainUnverified: gettext('Unable to verify domain'),
		paymentStatusCreated: gettext('Payment status has been created'),
		paymentStatusUpdated: gettext('Payment status has been updated'),
		paymentStatusDeleted: gettext('Payment status has been deleted'),
		minimumPaymentStatusesError: gettext('Unable to delete status, at least one payment status is required in each category'),
	},
	generalSettings: {
		title: gettext('General'),
		subtitle: gettext('Control basic settings for your site'),
		tabs: {
			siteDetailsTab: {
				tabLabel: gettext('Site Details'),
				siteDetails: gettext('Site Details'),
				images: gettext('Images'),
				siteName: gettext('Site Name'),
				siteTagline: gettext('Site Tagline'),
				siteLogo: gettext('Site Logo'),
				siteFavicon: gettext('Site Favicon'),
				organizationName: gettext('Organization Name'),
				logo: gettext('Logo'),
				favicon: gettext('Favicons'),
			},
			siteAccessTab: {
				tabLabel: gettext('Site Access'),
				siteAccess: gettext('Site Access'),
				requireMfaLabel: gettext('Require Multi-factor authentication for all users (native login only)'),
				lockSite: gettext('Lock this site so it is only accessible by administrators'),
				lockedMessage: gettext('Locking your site will stop any non-administrator from logging in.'),
				domain: gettext('Domain'),
				domains: gettext('Domains'),
				language: gettext('Language'),
				customDomains: gettext('Custom Domains'),
				addCustomDomain: gettext('Add custom domain'),
				dnsFailedPopoutTitle: gettext('DNS Verification Failed'),
				dnsFailedPopoutBody: gettext('We were unable to verify the DNS record for the domain. Please check the record and try again.'),
				verified: gettext('Verified'),
				unverified: gettext('Unverified'),
				baseDomain: gettext('Base Domain'),
				siteURL: gettext('Site URL'),
				requireMfaInfo: gettext('Require the use of multi-factor authentication for all users. This will be enforced for all users who log in natively.'),
				learnMore: gettext('Learn more'),
				dnsVerification: gettext('DNS Verification'),
				actions: gettext('Actions'),
				selectDomainPlaceholder: gettext('Select a domain'),
				lockedMessageEditor: gettext('Locked message text editor'),
				mfaComingSoon: gettext('Require MFA (Coming Soon)'),
			},
			themeTab: {
				tabLabel: gettext('Theme'),
				theme: gettext('Theme'),
				whatTheme: gettext('What theme would you like to use?'),
				themeSelector: gettext('Theme Selector'),
				textPreview: gettext('Text Preview'),
				themePreview: gettext('Theme Preview'),
				buttonPreview: gettext('Button Style Preview'),
				sampleText: gettext('This is some sample text'),
				linkText: gettext('Link text'),
				mutedText: gettext('Muted text'),
			},
			localizationTab: {
				tabLabel: gettext('Localization'),
				localization: gettext('Localization'),
				dateFormatPlaceholder: gettext('Select date forma'),
				dateFormat: gettext('Date Format'),
				timeFormat: gettext('Time Format'),
				currency: gettext('Currency'),
				currencyPlaceholder: gettext('Select currency'),
				timezonePlaceholder: gettext('Select timezone'),
			},
			financialManagementTab: {
				tabLabel: gettext('Financial Management'),
				financialManagement: gettext('Financial Management'),
				overdrafting: gettext('Overdrafting'),
				overdraftingInfo: gettext('Enabling overdrafting allows deficits to be run in program and fund balances.'),
				awardStatuses: gettext('Award Statuses'),
				allocated: gettext('Award Allocated'),
				payment: gettext('Award Payment'),
				cancelled: gettext('Cancelled'),
				addStatus: gettext('Add status'),
				enableOverdrafting: gettext('Enable overdrafting'),
			},
		},
		modals: {
			addCustomDomain: {
				title: gettext('Add Custom Domain'),
				addDomain: gettext('Add domain'),
			},
			editCustomDomain: {
				title: gettext('Edit Custom Domain'),
				domainPlaceholder: gettext('Enter your custom domain'),
			},
			deleteCustomDomain: {
				title: gettext('Delete Custom Domain'),
				body: gettext('Are you sure you want to delete this custom domain?'),
			},
			general: {
				domainName: gettext('Domain name'),
				domainLanguage: gettext('Domain language'),
				domainLanguagePlaceholder: gettext('Select a language'),
				domainPlaceholder: gettext('Enter your custom domain'),
				dnsInfo: gettext('To use a custom domain, add a CNAME record to your domain\'s DNS records. The CNAME should be a subdomain of your organization\'s domain and point to '),
				anchorRecords: gettext('Anchor records (A Record) are not supported and may result in users being unable to access your site.'),
				propagation: gettext('DNS changes may take up to 48 hours to propagate.'),
			},
			addAwardStatusModal: {
				addTitle: gettext('Add Award Status'),
				editTitle: gettext('Edit Award Status'),
				body: gettext('Use your own award statuses to track the status of payments made through financial management.'),
				categoryChoice: gettext('Select a category for the new award status'),
				statusName: gettext('Status name'),
			},
			deleteAwardStatus: {
				title: gettext('Delete Award Status'),
				body: gettext('Are you sure you want to delete this award status? This cannot be undone.'),
				selectReplacement: gettext('Select another payment status to replace any instances where this status is being used:'),
				replaceWith: gettext('Replace with:'),
				invalidSelection: gettext('Please select a replacement status'),
			},
			toggleMFARequired: {
				titleEnable: gettext('Require Multi-factor Authentication'),
				titleDisable: gettext('Disable Multi-factor Authentication Requirement'),
				bodyEnable: gettext('Enabling this setting <strong>immediately</strong> requires all users using native authentication (excludes users signed in via SSO & Google Sign On) to set up multi-factor authentication. <br/><br/><strong>We recommend enabling this during a low‑usage period to minimize disruption</strong>. Once a user enables MFA, they must continue to use it when signing in, even if this setting is later disabled, unless they remove it from their account.'),
				bodyDisable: gettext('Disabling this setting removes the MFA requirement for new users who register or log in using native authentication. <strong>Users who have already enabled MFA will still be required to use it</strong>.'),
				learnMore: gettext('Learn more'),
				confirmationText: gettext('I acknowledge that changing this setting will affect all users who log in natively to this site.'),
			}
		},
	},
};
export default STRINGS;
